import { sendAdminNotificationRequestParamsSchema, sendAdminNotificationResponseSchema, } from '../../../../../backend/features/contact-us/shared/platform-functions/types/sendAdminNotification';
export const sendAdminNotificationDef = {
    name: 'sendAdminNotification',
    requestSchema: sendAdminNotificationRequestParamsSchema,
    responseSchema: sendAdminNotificationResponseSchema,
};
export const sendAnonymousAdminNotificationDef = {
    name: 'sendAnonymousAdminNotification',
    requestSchema: sendAdminNotificationRequestParamsSchema,
    responseSchema: sendAdminNotificationResponseSchema,
};
